import TypedSelect from "common/ui/TypedSelect";
import Offer from "domain/offer";
import React, { useState } from "react";
import { Row, Col, Form } from 'react-bootstrap';
import FcmAccount from "features/fcmAccounts/fcmAccount";
import NumberEditor from "common/ui/NumberEditor";
import calculateNumberOfContracts from './contractCalculator';
import { OrderType } from "domain/orderType";
import { localizeOfferContract as localize, localizeCommon } from "features/localization/localizeService";

export type OfferHedgeSettingsProps = {
    offer: Offer;
    fcmAccounts: FcmAccount[];
    onOfferUpdated(offer: Offer, deliveryMethodUpdated?: boolean): void;
    isPlaceHedgeOrderChecked: boolean;
    setPlaceHedgeOrderChecked(value: boolean): void;
};

const OfferHedgeSettings: React.FC<OfferHedgeSettingsProps> = (props: OfferHedgeSettingsProps) => {

    const [showHedgeSettings, setShowHedgeSettings] = useState(props.isPlaceHedgeOrderChecked);

    if (props.offer == null) return null;

    return <>
        {props.offer.orderType === OrderType.ManualEntry && <Form.Group as={Row}>
            <Form.Label column>{localize("Details_Label_RecordHedgeOrder")}</Form.Label>
            <Col md="8">
                <Form.Check type="switch" id="placeLimitOrder" label="" className="d-inline-block" checked={showHedgeSettings}
                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => { 
                        setShowHedgeSettings(event.target.checked);
                        props.setPlaceHedgeOrderChecked(event.target.checked);
                    }}/>
            </Col>
            
        </Form.Group>}
        {showHedgeSettings && <HedgeSettingDetails {...props} />}
    </>
}

const HedgeSettingDetails: React.FC<OfferHedgeSettingsProps> = props => {

    const maxContracts = props.offer.orderType === OrderType.ManualEntry ? 500 : 100;

    return <>
        <Form.Group as={Row}>
            <Form.Label column>{localize("Details_Label_FcmAccount")}</Form.Label>
            <Col md="8">
                <TypedSelect
                    required
                    options={props.fcmAccounts ?? []}
                    value={props.offer.fcmAccount}
                    valueGetter={m => m.id}
                    textGetter={m => m.accountNumber}
                    showNullRow
                    nullRowText={localizeCommon("Value_Select")}
                    onValueSelected={m => props.onOfferUpdated({ ...props.offer, fcmAccount: m })} />
            </Col>
        </Form.Group>
        {(props.offer.commodity?.miniContractSize || props.offer.futuresContract.commodity?.miniContractSize) && <Form.Group as={Row}>
            <Form.Label column>{localize("Details_Label_UseMiniContracts")}</Form.Label>
            <Col md="8" className="pt-1">
                <Form.Check type="switch" id="at-use-minis" label="" className="d-inline-block" checked={props.offer.useMini}
                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => props.onOfferUpdated({ ...props.offer, useMini: event.target.checked, 
                        numberOfContracts: calculateNumberOfContracts(props.offer.deliveryPeriod?.commodity, props.offer.quantity, event.target.checked) })}/>
                        
            </Col>
        </Form.Group>}
        <Form.Group as={Row}>
            <Form.Label column>{localize("Details_Label_Contracts")}</Form.Label>
            <Col md="8">
                <NumberEditor className="form-control"
                    // disabled={isEditDisabled}
                    required
                    min={1}
                    isInvalidMessage={localize("Details_Validation_ContractExceedsMax", {max: maxContracts})}
                    max={maxContracts}
                    step={1}
                    value={props.offer.numberOfContracts}
                    onValueChange={value => props.onOfferUpdated({ ...props.offer, numberOfContracts: value })}
                    validationName="numberOfContracts"
                />
            </Col>
        </Form.Group>
    </>;
}

export default OfferHedgeSettings;